import React from 'react';
import { StarIcon } from 'lucide-react';
import { coaches } from '../data/coaches';
type RatingProofProps = {
  tone?: 'light' | 'dark';
};
export function RatingProof({
  tone = 'light'
}: RatingProofProps) {
  const isDark = tone === 'dark';
  return <div className="flex items-center gap-3" data-id="element-272" data-mp="3bohdkva8hpvq">
      <div className="flex shrink-0 -space-x-2" data-id="element-273" data-mp="3ghskewf1q6nn">
        {coaches.map(coach => <img key={coach.name} src={coach.avatar} alt={`${coach.name}, ${coach.role}`} className={`h-9 w-9 shrink-0 rounded-full object-cover ring-2 ${isDark ? 'ring-navy-deep' : 'ring-white'}`} loading="lazy" data-id="element-274" data-mp="3lgneiuigrhn2" />)}
      </div>
      <div className={`min-w-0 text-[13px] leading-tight ${isDark ? 'text-white/75' : 'text-navy-soft'}`} data-id="element-275" data-mp="3bafxc88ugc7">
        <div className="flex items-center gap-0.5" role="img" aria-label="Rated 4.9 out of 5" data-id="element-276" data-mp="203kg6hy58k0t">
          {Array.from({
          length: 5
        }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-peach text-peach" aria-hidden="true" data-id="element-277" data-mp="25481cmzoy6n4" data-mpi={i} />)}
          <span className={`ml-1.5 font-semibold ${isDark ? 'text-white' : 'text-navy'}`} data-id="element-278" data-mp="1ee4xpj1dos63">4.9/5</span>
        </div>
        <p className="mt-1" data-id="element-279" data-mp="14mh1l4tvmmya">
          Loved by <span className={`font-semibold ${isDark ? 'text-white' : 'text-navy'}`} data-id="element-280" data-mp="14nims24lwptq">1,200+</span>{' '}
          dance &amp; fitness instructors
        </p>
      </div>
    </div>;
}